import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import CurrencyFlagDynamicImage from './CurrencyFlagDynamicImage';

const CurrencySelectorComponent = ({ t, onCurrencyChange, selectedCurrency, exposureCurrencies }) => {
  return (
    <Box mt={3}>
      <Autocomplete
        id={'exposureCard_currency'}
        options={exposureCurrencies}
        value={selectedCurrency || ''}
        labelKey='code'
        valueKey='id'
        simpleValue={false}
        getOptionLabel={option => (option ? `${option.code} - ${option.name}` : '')}
        onChange={onCurrencyChange}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        renderOption={(props, option) => (
          <Box component='li' {...props}>
            <CurrencyFlagDynamicImage flagCode={option.code} />
            {option.code} - {option.name}
          </Box>
        )}
        renderInput={params => {
          return (
            <>
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps
                }}
                startAdornment={<CurrencyFlagDynamicImage flagCode={selectedCurrency?.code} />}
                value={params?.value}
                label={t('Document.Exposure.CurrencyLabel')}
              />
            </>
          );
        }}
      />
    </Box>
  );
};

CurrencySelectorComponent.propTypes = {
  t: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  selectedCurrency: PropTypes.object,
  exposureCurrencies: PropTypes.array
};

export default withTranslation()(CurrencySelectorComponent);
